export default __webpack_public_path__ + "static/media/logo-header.51572d0b.png";